export default __webpack_public_path__ + "static/media/mariaFilo_mob_banner_2.3a5343e6.jpg";